<script setup lang="ts">
import { axiosInstall } from '@/api'
import { ConfirmPopup, Toast, useToast } from 'primevue'

const toast = useToast()

axiosInstall({
  toast: () => toast,
})
</script>

<template>
  <Toast position="bottom-left" group="bl" />
  <ConfirmPopup />
  <slot />
</template>
